import { Component, OnDestroy } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription, catchError, tap } from 'rxjs';

import { Concurso } from '@core/models/concurso';
import { ConcursoApiService } from '../services/concurso-api.service';
import { FiltroConcurso } from './filtro';
import { UiService } from '@core/services/ui.service';

@Component({
	templateUrl: './tabela-concurso.component.html',
	providers: [MessageService, ConfirmationService]
})
export class TabelaConcursoComponent implements OnDestroy {
	pesquisarAoCarregar = true;
	habilitarFiltroCadastradoUsuario = false;
	filtros?: FiltroConcurso;
	limparFormularioPesquisa = false;
	resultado: any[] = [];
	loadingResultado = false;
	totalResultado?: number;
	pagina = 1;
	itensPorPagina = 10;
	primeiroItemResultado = 0;
	colunas: any;
	itemTabela = new Concurso();
	operacao?: string;
	exibirModalManterTabela = false;
	tituloModalManterTabela = '';
	subscriptions: Subscription[] = [];
	registrosSelecionados: Concurso[] = [];
	mensagensErro: any[] = [];

	public messageService: MessageService;

	constructor(
		private confirmationService: ConfirmationService,
		private tabelaService: ConcursoApiService,
		messageService: MessageService,
		private ui: UiService
	) {
		this.messageService = messageService;
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach(subscription => subscription.unsubscribe());
	}

	prepararCadastrar() {
		this.limparMensagensErro();
		this.tituloModalManterTabela = 'Cadastrar concurso';
		this.itemTabela = new Concurso();
		this.operacao = 'cadastrar';
		this.exibirModalManterTabela = true;
	}

	prepararAlterar(event: any) {
		this.limparMensagensErro();
		this.subscriptions.push(
			this.tabelaService.obterConcurso(event.id).subscribe(res => {
				this.itemTabela = new Concurso(
					res.id,
					res.nome,
					res.utiliza_perfil,
					res.codigo,
					res.questionario![0].orientacao,
					res.situacao
				);
				this.tituloModalManterTabela = 'Alterar concurso';
				this.operacao = 'alterar';
				this.exibirModalManterTabela = true;
			})
		);
	}

	salvarItem(event: Concurso) {
		const concurso = new Concurso();
		concurso.id = event.id;
		concurso.nome = event.nome;
		concurso.codigo = event.codigo;
		concurso.orientacao = event.orientacao;

		concurso.utiliza_perfil = event.utiliza_perfil ? true : false;
		if (this.operacao === 'cadastrar') {
			this.salvarNovo(concurso);
		} else if (concurso.id) {
			this.alterar(concurso.id, concurso);
		}
	}

	executarPesquisar(event: any) {
		this.filtros = new FiltroConcurso(undefined, event.nome, event.codigo, event.utiliza_perfil, event.situacao);
		this.primeiroItemResultado = 0;
		this.pagina = 1;
		this.messageService.clear();
		this.pesquisar();
		this.criarColunas();
	}

	atualizarResultado() {
		this.limparMensagensErro();
		this.pesquisar();
	}

	limparFormulario() {
		if (this.pesquisarAoCarregar) {
			this.executarPesquisar(new FiltroConcurso());
			this.limparFormularioPesquisa = true;
		} else {
			this.resultado = [];
		}
	}

	excluirItem(event: any) {
		this.limparMensagensErro();
		const concurso = event;
		this.confirmationService.confirm({
			message: 'Esta ação não poderá ser desfeita.',
			header: 'Deseja excluir o concurso ' + concurso.nome + '?',
			accept: async () => {
				this.tabelaService.excluirConcurso(event.id).subscribe(
					async (res: any) => {
						this.exibirMensagemSucesso(res);
					},
					err => {
						this.criarMensagem('error', err.error.message);
					}
				);
			}
		});
	}

	fecharModal() {
		this.exibirModalManterTabela = false;
		this.itemTabela = new Concurso();
		this.operacao = 'cadastrar';
		this.limparMensagensErro();
	}

	paginar(event: any) {
		this.pagina = event.first / event.rows + 1;
		this.primeiroItemResultado = event.first;
		this.itensPorPagina = event.rows;
		this.pesquisar();
	}

	getItensPorPagina(event: any) {
		this.itensPorPagina = event.rows;
	}

	private pesquisar() {
		this.resultado = [];
		this.loadingResultado = true;
		console.log('filtro', this.filtros);
		if (this.filtros) {
			this.subscriptions.push(
				this.tabelaService.obterConcursos(this.filtros, this.pagina, this.itensPorPagina).subscribe(
					(resultado: any) => {
						this.loadingResultado = false;
						this.totalResultado = resultado.metadata.total;
						this.pagina = resultado.metadata.page;
						this.tratarDados(resultado.items);
					},
					err => {
						this.totalResultado = 0;
						this.resultado = [];
						this.criarMensagem('error', err.error.message);
					}
				)
			);
		}
	}

	private criarColunas() {
		this.colunas = [
			{ field: 'nome', header: 'Nome' },
			{ field: 'codigo', header: 'Código' },
			{ field: 'situacao', header: 'Situação' },
			{ field: 'utiliza_perfil', header: 'Habilitado para Perfil' }
		];
	}

	private tratarDados(itens: any[]) {
		for (const item of itens) {
			const resultadoTratado = {
				id: item.id,
				nome: item.nome,
				codigo: item.codigo,
				situacao: item.situacao.descricao,
				acoesPossiveis: item.acoesPossiveis,
				utiliza_perfil: item.utiliza_perfil ? 'Sim' : 'Não'
			};
			this.resultado.push(resultadoTratado);
		}
	}

	private salvarNovo(concurso: Concurso) {
		this.subscriptions.push(
			this.tabelaService.incluirConcurso(concurso).subscribe(
				(res: any) => {
					this.exibirMensagemSucesso(res);
					this.exibirModalManterTabela = false;
					this.mensagensErro = [];
				},
				err => {
					this.exibirModalManterTabela = true;
					this.mensagensErro = [{ severity: 'error', summary: '', detail: err.error.message }];
				}
			)
		);
	}

	private alterar(id: number, concurso: Concurso) {
		this.subscriptions.push(
			this.tabelaService.alterarConcurso(id, concurso).subscribe(
				(res: any) => {
					this.exibirModalManterTabela = false;
					this.mensagensErro = [];
					this.exibirMensagemSucesso(res);
				},
				err => {
					this.exibirModalManterTabela = true;
					//this.criarMensagem('error', err.error.message);
					this.mensagensErro = [{ severity: 'error', summary: '', detail: err.error.message }];
				}
			)
		);
	}

	private criarMensagem(criticidade: string, mensagem: string) {
		this.messageService.clear();
		this.messageService.add(this.ui.criarMensagem(criticidade, '', mensagem));
	}

	private exibirMensagemSucesso(res: any) {
		if (res) {
			this.criarMensagem('success', res.message);
			this.limparPesquisa();
		}
	}

	limparMensagensErro() {
		this.mensagensErro = [];
	}

	private limparPesquisa() {
		this.limparFormularioPesquisa = true;
		this.primeiroItemResultado = 0;
		this.pagina = 1;
		this.pesquisar();
	}
}
